import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import { action, makeObservable, observable } from 'mobx';







export var CustomFieldControl = /*#__PURE__*/function () {





















  function CustomFieldControl(_ref)



  {var initialValue = _ref.initialValue,_ref$disabled = _ref.disabled,disabled = _ref$disabled === void 0 ? false : _ref$disabled,_ref$initialValidatio = _ref.initialValidationStatus,initialValidationStatus = _ref$initialValidatio === void 0 ? false : _ref$initialValidatio;_classCallCheck(this, CustomFieldControl);_defineProperty(this, "disabled", false);
    this.value = initialValue;
    this.initialValue = initialValue;
    this.disabled = disabled;
    this.isFieldValid = initialValidationStatus;

    makeObservable(this, {
      value: observable,
      isFieldValid: observable,
      disabled: observable,
      initialValue: observable,
      updateDisabledStatus: action.bound,
      updateValue: action.bound,
      resetField: action.bound,
      updateValidationStatus: action.bound
    });
  }_createClass(CustomFieldControl, [{ key: "updateDisabledStatus", value: function updateDisabledStatus(newStatus) {this.disabled = newStatus;} }, { key: "updateValidationStatus", value: function updateValidationStatus(newStatus) {this.isFieldValid = newStatus;} }, { key: "updateValue", value: function updateValue(newValue) {this.value = newValue;} }, { key: "resetField", value: function resetField() {this.value = this.initialValue;} }]);return CustomFieldControl;}();
//# sourceMappingURL=CustomFieldControl.js.map